import Controller from '@ember/controller'
import { type PaginationConfig } from '@blakeelearning/data-tables/utils/paging'
import { tracked } from '@glimmer/tracking'
import {
  updateSortColumns,
  deserialize as deserializeSort,
  serialize as serializeSort,
} from '@blakeelearning/data-tables/utils/sorting'

export default class extends Controller {
  queryParams = ['sort', 'pageNumber', 'perPage']
  // defaults
  @tracked sort = 'first_name'
  @tracked pageNumber = 1
  @tracked perPage = 10

  get sortingConfig() {
    return deserializeSort(this.sort)
  }

  set sortingConfig(newSortConfig) {
    this.sort = serializeSort(newSortConfig)
  }

  get paginationConfig(): PaginationConfig {
    return { pageNumber: Number(this.pageNumber), perPage: Number(this.perPage) }
  }

  /**
   * This action should be called when a column is clicked, it sets the new sortingConfig for the URL query params
   */
  updateSorts = ({ sortKey }: SortObject) => {
    if (sortKey) {
      const newSortConfig = updateSortColumns(this.sortingConfig, sortKey as string)
      this.sortingConfig = newSortConfig
    }
  }
}
